import axios from "axios";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
// import { confirmAlert } from "react-confirm-alert"; // Import
// import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { API_URL } from "../config";
import { useGlobalLoading } from "../contexts/Loading";
import {
  formatEpochDate,
  formatEpochTime,
  randomString,
} from "../helpers/helperFunctions";
import { classNames } from "../helpers";
import { BiEdit } from "react-icons/bi";
import { useToast } from "./ui/use-toast";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import {
  AiOutlineClockCircle,
  AiOutlineDelete,
  AiOutlineThunderbolt,
  AiTwotoneThunderbolt,
} from "react-icons/ai";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { FaTrash } from "react-icons/fa";
import { MdOutlineDateRange } from "react-icons/md";
import { Separator } from "./ui/separator";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "./ui/hover-card";
import Loader from "./Loader";
import { CURRENT_BROKER_NAME } from "@/config/logos";

const AlertStrategyModal: any = (props: any) => {
  const { toast } = useToast();
  const router = useRouter();
  const { t } = useTranslation("alert-strategy");
  const { alertModal, setAlertModal, userInfo, strategyId, getData } = props;
  const [reportVersion, setReportVersion] = useState("0");
  const [backtestReport, setBacktestReport] = useState<any>();
  const [notificationDeployed, setNotificationDeployed] = useState(2);
  const [strategyData, setStrategyData] = useState<any>([]);
  const [strategyParentData, setStrategyParentData] = useState<any>([]);
  const [editSN, setEditSN] = useState(false);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [deployLive, setDeployLive] = useState(true);
  const [deploymentId, setDeploymentId] = useState("");
  const globalLoading = useGlobalLoading();
  const [isAlertStrategy, setIsAlertStrategy] = useState(false);

  useEffect(() => {
    strategyId && userInfo && getStrategyDetails(userInfo.user_id, strategyId);
  }, [strategyId]);

  const setAuthHeader = (token: string) => {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  };
  const getStrategyDetails = (user_id: any, strategy_id: any) => {
    // setStrategyDetailsLoading(true);

    let url = new URL("get_strategy_details", API_URL);
    url.searchParams.append("user_id", userInfo.user_id as string);
    url.searchParams.append("strategy_id", strategyId as string);
    axios
      .get(url.toString(), setAuthHeader(userInfo.token))
      .then((res: any) => {
        if (res.statusText == "OK") {
          // getSize(user_id, strategy_id);
          let symbol = res.data?.strategy_details?.symbol;
          if (symbol) {
            let logo = "";
            let logourl = new URL("get_logos", API_URL);
            logourl.searchParams.append("symbols", symbol);
            logourl.searchParams.append(
              "server",
              `${CURRENT_BROKER_NAME}.trylevel2.com`
            );

            axios
              .get(url.toString(), setAuthHeader(userInfo.token))
              .then((r: any) => {
                for (var item in r.data.data) {
                  logo = r.data.data[item];
                  break;
                }
              })
              .catch((e) => {
                console.error(e);
              });
          }
          if (
            res.data.strategy_details.is_notification == "1" ||
            res.data.strategy_details.is_notification == 1
          ) {
            setIsAlertStrategy(true);
            setNotificationDeployed(
              res.data.deployment.is_notification_deployed
            );
            setDeploymentId(res.data.deployment.notif_depl_id);
          } else {
            setIsAlertStrategy(false);
            setDeploymentId("");
          }
          setStrategyData(res.data?.strategy_details);
          setStrategyParentData(res.data);
          // getReportVersions();
          // setConsolidateStats(res.data?.consolidated_stats);
          // setActionMetricsData(res.data?.action_metrics?.data[0]);
          setDeployLive(res.data?.deployment.is_live_deployed);
          // if (res.data?.ft_dep == true) {
          //     setDeployVirtual(true);
          // } else {
          //     setDeployVirtual(false);
          // }
        }
      })
      .catch((e) => {
        toast({
          title: "Something went wrong",
          variant: "destructive",
        });
        // setError(e.message);
        // throw new Error(e.message);
      });
    // .finally(() => setStrategyDetailsLoading(false));
  };

  const getReportVersions = () => {
    // setReportVersionLoading(true);
    axios
      .post(API_URL + "/get_all_report_versions", { strategy_id: strategyId })
      .then((res) => {
        if (res.statusText == "OK") {
          // setReportsData(res.data?.data);
          setReportVersion(res.data?.data[0]?.id || 0);
        }
      })
      .catch((e) => {
        console.error("error ", e.message);
        setError(e.message);
        // throw new Error(e.message);
      });
    // .finally(() => setReportVersionLoading(false));
  };

  const saveSn = () => {
    //@ts-ignore
    let sn = document.getElementById("strategyName").value;
    if (sn.toString().trim() == "") {
      return;
    }

    let url = new URL("change_strategy_name", API_URL);
    url.searchParams.append("user_id", userInfo.user_id);
    url.searchParams.append("strategy_id", strategyData.id);
    url.searchParams.append("strategy_name", sn);
    axios
      .post(url.toString(), {}, setAuthHeader(userInfo.token))
      .then((res: any) => {
        if (res.statusText == "OK") {
          // toast.success(res.data?.detail);
          setEditSN(false);
          getData();
          //setStrategyData({...strategyData,strategy_name: sn})
          // const u = JSON.parse(localStorage.getItem("user-info")!)
          setAlertModal((prev: any) => ({ ...prev, display: false }));
          // setUserInfo(u);
          // InitialData(u, id);
        }
      })
      .catch((e) => {
        console.error(e);
        // toast.error(e.response.data.detail);
        // throw new Error(e.message);
      });
  };
  const deleteStrategy = () => {
    let url = new URL("delete_strategy", API_URL);
    url.searchParams.append("user_id", userInfo.user_id);
    url.searchParams.append("strategy_id", strategyId);
    axios
      .post(url.toString(), {}, setAuthHeader(userInfo.token))
      .then((res) => {
        if (res.statusText == "OK") {
          // toast.success(res.data.detail);
          setAlertModal((prev: any) => ({ ...prev, display: false }));
          getData();
        }
      })
      .catch((e) => {
        // toast.error(e.response.data.detail);
        console.error("error ", e.message);
      });
  };
  const handleDeployLive = () => {
    if (isAlertStrategy) {
      setLoader(true);
      if (notificationDeployed) {
        let url = new URL("undeploy_notification_strategy", API_URL);
        url.searchParams.append("user_id", userInfo.user_id);
        url.searchParams.append("deployment_id", deploymentId.toString());
        axios
          .post(url.toString(), {}, setAuthHeader(userInfo.token))
          .then((res: any) => {
            if (res.statusText == "OK") {
              // InitialData(userInfo, id);
              // toast.success(res.data.message);
              getData();
              setAlertModal((prev: any) => ({ ...prev, display: false }));
            }
            // setModal(false);
          })
          .catch((e) => {
            console.error(e.message);
            // toast.error(e.response.data.detail);
            // throw new Error(e.message);
          })
          .finally(() => globalLoading.setLoading(false));
      } else {
        const formData = new FormData();
        formData.append("strategy_data", strategyData.strategy_data);
        formData.append("canvas_data", strategyData.canvas_data);
        let url = new URL("deploy_notification_strategy", API_URL);
        url.searchParams.append("keygen", strategyData.keygen.toString());
        // url.searchParams.append("strategy_id", strategyData.id.toString());
        axios
          .post(url.toString(), formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${userInfo.token}`,
            },
          })
          .then((res: any) => {
            if (res.statusText == "OK") {
              // InitialData(userInfo, id);
              // toast.success("Successfully deployed");
              getData();
            }
            setAlertModal((prev: any) => ({ ...prev, display: false }));
            // setModal(false);
          })
          .catch((e) => {
            console.error(e.message);
            // toast.error(e.response.data.detail.toString());
            // throw new Error(e.message);
          })
          .finally(() => globalLoading.setLoading(false));
      }
    }
    // else if (!deployLive) {
    //     setFormState(3);
    //     setModal(!modal);
    // }
    else {
      globalLoading.setLoading(true);
      axios
        .post(API_URL + "/undeploy_virtual_strategy", {
          deployment_id: deploymentId,
          user_id: userInfo?.user_id,
        })
        .then((res: any) => {
          if (res.statusText == "OK") {
            if (res.data.success == true) {
              // setDeployVirtual(false);
              globalLoading.setLoading(false);
              // recallWallet();
              // toast.success(res.data.message);
              getData();
            } else {
              globalLoading.setLoading(false);
              // toast(res.data.message);
            }
            setAlertModal((prev: any) => ({ ...prev, display: false }));
            // setModal(false);
          }
        })
        .catch((e) => {
          console.error(e.message);
          globalLoading.setLoading(false);
          throw new Error(e.message);
        });
    }

    setLoader(false);
  };
  const editStrategy = () => {
    router.push({
      pathname:
        "/edit-strategy/" +
        encodeURIComponent(userInfo?.user_id) +
        "/" +
        strategyId +
        randomString(5) +
        "/" +
        userInfo.token +
        "/false",
      query: {
        ref: router.asPath,
        locale: router.query.locale || "en",
      },
    });
  };
  const editButton = () => {
    const buttonLabelClass =
      "flex justify-center items-center gap-1 relative z-20";
    return (
      <div className="flex  gap-2 justify-center xl:gap-3 2xl:gap-5">
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button variant="secondary">
              <div className={buttonLabelClass}>
                {t("deleteStrategy")}
                <span className="align-middle">
                  <AiOutlineDelete />
                </span>
              </div>
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>
                {t("Are you absolutely sure?")}
              </AlertDialogTitle>
              <AlertDialogDescription>
                {t(
                  "Are you sure you want to delete? (This action is irreversible)"
                )}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <div className="flex items-center space-x-2">
              <AlertDialogAction
                onClick={() => {
                  deleteStrategy();
                }}
              >
                {t("Yes")}
              </AlertDialogAction>
              <AlertDialogCancel>{t("No")}</AlertDialogCancel>
            </div>
          </AlertDialogContent>
        </AlertDialog>
        <Button
          disabled={loader}
          variant="secondary"
          onClick={() => {
            handleDeployLive();
          }}
        >
          <div className={buttonLabelClass}>
            {notificationDeployed ? t("undeployAlert") : t("deployAlert")}
            {loader ? <Loader /> : <AiOutlineThunderbolt />}
          </div>
        </Button>
        <HoverCard>
          <HoverCardTrigger asChild>
            <div>
              <Button
                variant="secondary"
                className={buttonLabelClass}
                disabled={!!(deployLive || notificationDeployed)}
                onClick={() => {
                  deployLive || notificationDeployed ? {} : editStrategy();
                }}
              >
                {t("editAlert")}
                {loader ? (
                  <Loader />
                ) : (
                  <div className="cursor-pointer">
                    <BiEdit />
                  </div>
                )}
              </Button>
            </div>
          </HoverCardTrigger>
          {(deployLive || notificationDeployed) && (
            <HoverCardContent>{t("Undeploy to edit alert")}</HoverCardContent>
          )}
        </HoverCard>
      </div>
    );
  };
  return (
    <Dialog
      open={alertModal}
      onOpenChange={(open: any) => {
        setAlertModal(open);
      }}
    >
      <DialogContent className="h-fit max-w-[700px]  max-h-[650px] sm:max-h-[350px] lg:max-h-mcg overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{t("Alert")}</DialogTitle>
          <DialogDescription>{t("Alerthint")}</DialogDescription>
        </DialogHeader>

        <div className="flex flex-col ">
          <div className="px-2">
            <div className="flex flex-row items-center mt-3">
              {strategyData?.symbol}
            </div>
            <Separator className="my-5 " />
            <div className="flex flex-row justify-between text-sm">
              <div className="text-sm text-sky">
                {strategyData?.strategy_name}{" "}
                <span
                  onClick={() => setEditSN(!editSN)}
                  className="align-middle inline-flex cursor-hover"
                >
                  <BiEdit />
                </span>
              </div>
              <div className="text-xs">
                {t("timeframe")} - {strategyData?.timeframe}
              </div>
            </div>
            {editSN && (
              <div className="pt-2 pb-5 text-sm flex flex-col text-slate-400">
                <label className="text-slate-800 dark:text-white">
                  {t("strategyName")}
                </label>
                <Input
                  id="strategyName"
                  autoComplete="off"
                  type="text"
                  name="strategyName"
                  placeholder={t("strategyName")}
                  defaultValue={strategyData?.strategy_name || ""}
                  className="outline-none mt-1 mb-2"
                />
                <p className="text-right">
                  <Button onClick={() => saveSn()}>{t("save")}</Button>
                </p>
              </div>
            )}
            <div className="flex flex-row justify-between text-sm mb-8 ">
              <div className="text-xs gap-1 items-center flex mt-2">
                <MdOutlineDateRange />
                {formatEpochDate(strategyParentData?.epoch)}
              </div>
              <div className="text-xs gap-1 items-center flex mt-2">
                <AiOutlineClockCircle />
                {formatEpochTime(strategyParentData?.epoch)}
              </div>
            </div>
          </div>

          {editButton()}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AlertStrategyModal;
